import { BASE_PATH } from '@prophecy/utils/history';
import { matchPath } from 'react-router-dom';

import { Private_Routes } from './url';

export function isSqlIDE() {
  return Boolean(matchPath(`${BASE_PATH}${Private_Routes.SQL_IDE.url}`, window.location.pathname));
}
